// EditableText.js
// Component for an editable text input

// Imports
import React from 'react';
import { EditableText as BpEditableText } from '@blueprintjs/core';
import PropTypes from 'prop-types';

// Component Class
// Renders a text area which can be edited
class EditableText extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      editing: false
    };
  }

  // Callback for value editing
  editValue = (newValue) => {
    newValue = newValue.trim();
    if (newValue.length > 0 || this.props.allowBlank) {
      this.props.rename(newValue);
      
      if (this.props.clearAfterSet)
        this.setState({value: ""});
    }
    this.setState({editing: false});
  }

  // Callback to signalize that value changed
  onChange = (newValue) => {
    this.setState({value: newValue});
  }

  // Callback to signalize that changes are being made
  onEdit = () => {
    this.setState({value: this.props.value, editing: true});
  }

  // Renders Component
  render() {
    return <BpEditableText
      value={!this.state.editing ? this.props.value : this.state.value}
      placeholder={this.props.placeholder}
      onChange={this.onChange}
      onConfirm={this.editValue}
      onEdit={this.onEdit}
    />;
  }
}

// Required Properties
EditableText.propTypes = {
  value: PropTypes.string,            // Current value for the input
  allowBlank: PropTypes.bool,         // Indicates whether the field can be empty
  placeholder: PropTypes.string,      // Placeholder to be shown when there's no value
  rename: PropTypes.func.isRequired,  // Callback for when the value is changed
}

// Exports
export default EditableText;



// WEBPACK FOOTER //
// ./src/components/Common/EditableText.js